module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('h4', [_vm._v(_vm._s(_vm.utilLabel) + " Supply")]), _vm._v(" "), (_vm.isManager('finance|project|maintenance')) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.editState()
      }
    }
  }, [_c('i', {
    class: _vm.editing ? 'fa fa-check-circle' : 'fa fa-edit'
  })]) : _vm._e(), _vm._v(" "), (this.editing) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })]) : _vm._e()], 1), _vm._v(" "), _c('el-form', {
    ref: "utilityForm",
    attrs: {
      "inline": true,
      "label-position": "top",
      "model": _vm.details
    }
  }, [(_vm.canAccess('finance')) ? _c('el-form-item', {
    attrs: {
      "label": "Deposit"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.utilityDeposit),
      callback: function($$v) {
        _vm.$set(_vm.details, "utilityDeposit", $$v)
      },
      expression: "details.utilityDeposit"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canAccess('finance')) ? _c('el-form-item', {
    attrs: {
      "label": "Std. Rate"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.details.utilityStandardRate),
      callback: function($$v) {
        _vm.$set(_vm.details, "utilityStandardRate", $$v)
      },
      expression: "details.utilityStandardRate"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('util-equip', {
    attrs: {
      "site-id": _vm.details.site_id,
      "site-data": _vm.siteData,
      "owner-id": _vm.details.organisation_id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-691b5870"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/sharers/UtilityTab.vue
// module id = 1536
// module chunks = 0